(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8098],{

/***/ 31032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Spinner: () => Spinner
});
module.exports = __toCommonJS(src_exports);

// src/spinner.tsx
var import_system = __webpack_require__(26812);
var import_shared_utils = __webpack_require__(66307);
var import_jsx_runtime = __webpack_require__(85893);
var spin = (0, import_system.keyframes)({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});
var Spinner = (0, import_system.forwardRef)((props, ref) => {
  const styles = (0, import_system.useStyleConfig)("Spinner", props);
  const {
    label = "Loading...",
    thickness = "2px",
    speed = "0.45s",
    emptyColor = "transparent",
    className,
    ...rest
  } = (0, import_system.omitThemingProps)(props);
  const _className = (0, import_shared_utils.cx)("chakra-spinner", className);
  const spinnerStyles = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: thickness,
    borderBottomColor: emptyColor,
    borderLeftColor: emptyColor,
    animation: `${spin} ${speed} linear infinite`,
    ...styles
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_system.chakra.div,
    {
      ref,
      __css: spinnerStyles,
      className: _className,
      ...rest,
      children: label && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.chakra.span, { srOnly: true, children: label })
    }
  );
});
Spinner.displayName = "Spinner";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 47817:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/exchange",
      function () {
        return __webpack_require__(76142);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _prezzee_ribbon_ui_lib_components_Spinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93533);
/* harmony import */ var _prezzee_ribbon_ui_lib_components_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18636);
/* harmony import */ var _prezzee_ribbon_ui_lib_theme_foundations_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85171);
/* harmony import */ var contexts_AuthContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35248);


__webpack_require__(14473);





// @ts-ignore
var ExchangeRemote = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function() {
    return __webpack_require__.e(/* import() */ 3714).then(__webpack_require__.t.bind(__webpack_require__, 35400, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35400)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_prezzee_ribbon_ui_lib_components_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
            w: "100%",
            height: "500px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_prezzee_ribbon_ui_lib_components_Spinner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                emptyColor: "gray.200",
                color: _prezzee_ribbon_ui_lib_theme_foundations_colors__WEBPACK_IMPORTED_MODULE_3__["default"].red[400],
                size: "xl"
            })
        });
    }
});
var Exchange = function(props) {
    var updateMfa = (0,contexts_AuthContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)().updateMfa;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ExchangeRemote, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        updateMfa: updateMfa
    }, props));
};
/* harmony default export */ __webpack_exports__["default"] = (Exchange);


/***/ }),

/***/ 93533:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var spinner_1 = __webpack_require__(31032);
exports.Z = spinner_1.Spinner;


/***/ }),

/***/ 53875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://files.prezzee.co.nz/apps/partner-exchange/partner-exchange.remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["partner_exchange"]) {
      return resolve(window.remoteLoading["partner_exchange"])
    }

    var res, rej;
    window.remoteLoading["partner_exchange"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["partner_exchange"] !== 'undefined') {
      res(window["partner_exchange"]);
      return resolve(window["partner_exchange"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["partner_exchange"] !== 'undefined') {
          res(window["partner_exchange"]);
          return resolve(window["partner_exchange"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "partner_exchange"
    );
  }).then(function () {
    const proxy = {
      get: partner_exchange.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          partner_exchange.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        partner_exchange.__initialized = true
      }
    }
    if (!partner_exchange.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(47817); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);